/* eslint no-param-reassign: ["error", { "props": false }] */

const defaultState = () => ({
  sidebar: {
    collapsed: false,
  },
});

export default {
  namespaced: true,
  state: defaultState,
  getters: {
  },
  mutations: {
    TOGGLE_SIDEBAR({ sidebar }) {
      sidebar.collapsed = !sidebar.collapsed;
    },
  },
  actions: {
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR');
    },
  },
};
